<template>
    <div class="upgradeUser" v-loading="loading" element-loading-text="请求登陆中" element-loading-spinner="el-icon-eleme">
        <div class="box-card">
            <div v-show='type===1'>
                <h4>绑定用户</h4>
                <p>您当前没有绑定用户，当忘记密码时，无法登录帐号或申诉找回。请先绑定用户。</p>
                <el-form ref="formName" :model="form" label-width="65px" :rules="rules" label-position='left'>
                    <el-form-item label="用户名" prop='userName'>
                        <el-input placeholder="请输入用户名称" v-model="form.userName">
                            <!-- <template slot="prepend">国家码:+85</template> -->
                        </el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop='password'>
                        <el-input v-model="form.password" placeholder="请输入密码" type='password'>
                            <!-- <el-button @click='getCode' slot="append" type="primary" size="mini">{{isCode?`${count}秒后获取`:'获取验证码'}}</el-button> -->
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item> -->
                    <el-button class="btn" type="primary" @click='submitForm("formName")'>提交</el-button>
                    <!-- </el-form-item> -->
                </el-form>
            </div>
            <div v-show='type===2' class="success">
                <h4>绑定安全用户</h4>
                <img src="../assets/img/common/success.png" alt="">
                <div>绑定成功</div>
                <p>{{`${count}秒后页面进行跳转`}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import mainApi from "@/network/mainApi";
import { getUrlKey } from '@/utils/utils.js';
import { mapState } from 'vuex';
var validatePhone = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入手机号'));
    }
    const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
    if (reg.test(value)) {
        callback();
    } else {
        callback(new Error('手机号格式不正确'));
    }
};
export default {
    name: "",
    data() {
        return {
            form: {
                userName: "",
                password: "",
            },
            type: 0,  // 是否绑定成功
            count: '0',  //倒计时3秒跳转网页
            loading: true,
            isCode: false,
            rules: {
                userName:
                    // { validator: validatePhone, trigger: 'blur' },
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                password:
                    { required: true, message: '请输入验证码', trigger: 'change' }
            }
        };
    },
    computed: {
    },
    methods: {
        getInitData() {
            const data = {
                code: getUrlKey('code'),
                appId: getUrlKey('appId'),
                state: localStorage.getItem('state')
            }
            mainApi.useCode(data).then((res) => {
                if (res.data.code == 200) {
                    if (res.data.msg === '未绑定') {
                        // 需要绑定手机号
                        this.type = 1
                        this.loading = false;
                        this.userCode = res.data.data
                    }
                    if (res.data.data.username) {
                        this.goLogin(res.data.data)
                    }

                } else {
                    setTimeout(() => {
                        this.$router.push({ path: "/login" })
                    }, 3000)
                    this.loading = false;
                    this.$message.success(res.data.msg);
                }

            })
        },
        goLogin(data) {
            mainApi
                .login({
                    username: data.username,
                    password: data.password
                })
                .then((res) => {
                    // console.log(res.data, "res");
                    let { code, data, msg } = res.data;
                    if (code == 200) {
                        this.loading = false;
                        localStorage.setItem(
                            "token",
                            data.access_token
                        );
                        localStorage.setItem(
                            "userInfo",
                            JSON.stringify(data)
                        );
                        this.$store.commit("setIsLogin", "true");
                        this.$message.success("登录成功");
                        setTimeout(
                            this.$router.push({ path: "/home" }), //通过this.$router访问路由实例，调用push方法可以导航到不同的URL中。
                            500
                        );
                    } else {
                        this.$message.error(msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 绑定用户
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 清除获取验证码的定时器
                    // this.times && clearInterval(this.times);
                    const data = {
                        userCode: this.userCode,
                        ...this.form
                    }
                    mainApi.updateUser(data).then((res) => {
                        if (res.data.code == 200) {
                            this.type = 2 //显示成功页面
                            this.count = 3; //倒计时3秒跳转页面
                            this.times = setInterval(() => {
                                this.count--;
                                if (this.count <= 0) {
                                    clearInterval(this.times);
                                    this.goLogin(res.data.data)
                                }
                            }, 1000); //1000毫秒后执行
                        }else{
                            this.$message(res.data.msg)                            
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // getCode() {
        //     this.isCode = true;
        //     this.count = 60;
        //     this.times = setInterval(() => {
        //         this.count--;
        //         if (this.count <= 0) {
        //             clearInterval(this.times);
        //             this.isCode = false
        //         }
        //     }, 1000); //1000毫秒后执行
        //     mainApi.loginSms({ phone: this.form.tel }).then((res) => {
        //         if (res.data.code === 200) {
        //             clearInterval(this.times);
        //             this.isCode = false
        //         }
        //     });
        // },
    },
    created() {
        // this.loading = true;
        this.getInitData();
    },
    beforeDestroy() {
        clearInterval(this.times);
    }
};
</script>

<style lang="scss" scoped>
.box-card {
    width: 500px;
    margin: 150px auto;
    h4 {
        font-size: 25px;
        text-align: center;

        // font-weight: ;
    }
    p {
        font-size: 15px;
        padding: 10px 0;
        color: #909399;
        letter-spacing: 1px;
    }
    .btn {
        width: 100%;
    }
    .success {
        text-align: center;
        margin-top: 30px;
        img {
            width: 90px;
        }
        div {
            font-size: 13px;
            padding: 10px 0;
        }
        p {
            margin-top: 20px;
        }
    }
}
::v-deep .el-icon-eleme {
    font-size: 30px;
    animation: rotating 2s linear infinite;
}
::v-deep .el-input-group__append {
    // border: none;
    background-color: #409eff;
    // .el-button--primary {
    //     background-color: #409eff;
    color: #fff;
    //     // width: 80px;
    // }
}
// ::v-deep .el-form-item__error {
//     display: none;
// }
</style>
